import _ from 'lodash';

// retourne la locale courante de l'url si non trouvée ou invalide alors locale par defaut
export function getLocaleFromRoutes(pathname, locales, defaultLocale) {
    if (!pathname || pathname === undefined || !_.isString(pathname)) {
        return defaultLocale;
    }
    const locale = pathname.split('/')[1];
    return locale && _isLocaleReconnue(locale, locales, defaultLocale) ? locale : defaultLocale;
}

/**
 * retourne true si 'locale' est une string et si elle correspond à une entrée dans le tableau locales ou à la locale par défaut
 * Lance un exception si locales et defaultLocale sont vide ou undefined
 * @param {String} locale
 * @param {Array} locales
 * @param {String} defaultLocale
 */
export function _isLocaleReconnue(locale, locales, defaultLocale) {
    if (!locales && locales === undefined && !defaultLocale && defaultLocale === undefined) {
        throw new Error(
            '[_isLocaleReconnue] : Au moins un de ces deux paramètres [locales, defaultLocale] doit être défini.',
            'features/i18n/utils.js',
            25
        );
    }
    if (_.isString(locale)) {
        if (_.isEmpty(locales)) {
            return locale === defaultLocale;
        } else {
            return _.includes(locales, locale);
        }
    } else {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/services/i18n/utils.js